/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://939gqob0mh.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "stripeHandlerApi",
            "endpoint": "https://t0wtlu7zua.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qn5vaeod6vdxrbfu77rglunaze.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-756civfrv5hy5azdheu624hsbi",
    "aws_cognito_identity_pool_id": "us-east-1:7ce7f2bb-b5bd-4768-a010-7d22e0487eac",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_KMaQ3qGQN",
    "aws_user_pools_web_client_id": "2lqalrvj1i40snv54o56kds9o5",
    "oauth": {
        "domain": "timersrn912676d2-912676d2-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:19006/,https://www.dev.app.timerz.io/,https://www.staging.app.timerz.io/,https://www.app.timerz.io/",
        "redirectSignOut": "http://localhost:19006/,https://www.dev.app.timerz.io/,https://www.staging.app.timerz.io/,https://www.app.timerz.io/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "timersrn85e5a921bae548a290c1c15cbcbc8a689bb7b-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
